var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwissquote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8809 0C25.7929 0 32.8809 7.08793 32.8809 16C32.8809 24.9109 25.7929 32 16.8809 32C7.96879 32 0.880859 24.9109 0.880859 15.9989C0.880859 7.08793 7.96879 0 16.8809 0ZM24.8633 11.9742V9.32474H8.8973V11.9742H24.8633ZM22.2138 22.6741H24.8633V14.6577H8.8973V22.6741H11.5468V19.646C11.5468 18.7867 11.7542 18.3037 12.0637 17.9602C12.4073 17.5475 12.9242 17.306 13.5432 17.306C14.1622 17.306 14.6781 17.5464 15.0227 17.9602C15.3322 18.3037 15.5397 18.7867 15.5397 19.646V22.6741H18.2232V19.646C18.2232 18.7867 18.4295 18.3037 18.7401 17.9602C19.0837 17.5475 19.5995 17.306 20.2196 17.306C20.8398 17.306 21.3545 17.5464 21.6991 17.9602C22.0086 18.3037 22.2161 18.7867 22.2161 19.646V22.6741H22.2138Z",
    fill: "#FA5B35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwissquote);
export default __webpack_public_path__ + "static/media/Swissquote.1628732e5ea7f15e909b850ee0b190fe.svg";
export { ForwardRef as ReactComponent };